import moment from 'moment';
import { TEventTag } from '../types/events';

export interface RegisteredByInspectorEvent {
    role: string;
}

export interface IInspectorEvent {
    date: string;
    _id: string;
    description: string;
    bookingID: string;
    type: string;
    eventType?: string;
    createdAt: Date;
    updatedAt: Date;
    registeredBy?: RegisteredByInspectorEvent;
    tag?: TEventTag;
    metadata?: any;
}

export class InspectorEvent implements IInspectorEvent {
    _id: string;

    description: string;

    bookingID: string;

    type: string;

    updatedAt: Date;

    createdAt: Date;

    registeredBy?: RegisteredByInspectorEvent;

    tag?: TEventTag;

    metadata?: any;

    constructor({ date, ...partial }: InspectorEvent) {
        Object.assign(this, partial);
    }

    get date() {
        return moment(this.createdAt).format('HH:mm:ss:SSS');
    }
}
